import { Colors } from "../../../utils/style/colors";

// Tile catalog for the custom App page. Each descriptor maps to a Config editor
// (Configs/index.js, keyed by `config`) and is rendered by AppTile (keyed by
// `type`). Icons are referenced by their export name in utils/icons.
export const getAppTiles = (t) => [
  {
    type: "quickButton",
    title: t("quickButtonTile", { defaultValue: "Quick button" }),
    description: t("startScenario.tile.description"),
    icon: "ButtonIcon",
    color: Colors.secondary(),
    config: "quickButtonScenario",
  },
  {
    type: "text",
    title: t("textTile", { defaultValue: "Text" }),
    description: t("freeText.tile.description"),
    icon: "TextIcon",
    color: Colors.gray30,
    config: "textTile",
  },
];
